import { FeApi } from '@/api/fe-api';
import type { TimeBasedMetrics } from '@/warranty-v3/entities/metric';

import { metricsGroupMapper } from './metrics-group-mapper';

export function metricsOutputMapper(
  data: FeApi.MetricsOutput,
): TimeBasedMetrics {
  const isDataAvailable = (data.start as string | null) != null;
  return {
    start: isDataAvailable ? new Date(data.start as string) : new Date(0),
    end: isDataAvailable ? new Date(data.end as string) : new Date(0),
    currency: data.currency,
    groups: data.groups?.map(metricsGroupMapper) ?? [],
    isDataAvailable,
  };
}
